import { Component, OnInit, AfterContentInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { Student } from '../student-list/student';
import { StudentService } from '../_services/student.service';
import { PhaseService } from '../_services/phase.service';
//import { DataStorageService } from '../_services/data-storage.service';

@Component({
	selector: 'student-card',
	templateUrl: './student-card.component.html',
})
export class StudentCardComponent implements OnInit {
	activeStudent: any;
	loading: any;
	show: boolean;
	currentTestSystem: any;
	color: string;
	totalScore: number;
	total: number;
	selectedStudent: Subscription;
	activePhase: any;
	showPopUpPhase: boolean;
	showLastPhase: boolean = false;
	allPhases = [];
	constructor(private StudentService: StudentService, private phaseService: PhaseService) {}

	ngOnInit(): void {
		this.loading = true;
		this.currentTestSystem = {
			name: 'Phonics Advantage Reading Assessment',
			id: 1,
		};
		this.total = 100;
		this.totalScore = 0;
		this.color = '#e5e4e2';
		this.phaseService.phases$.subscribe((allPhases: any) => {
			this.allPhases = allPhases;
			this.selectedStudent = this.StudentService.selectedStudent$.subscribe((data: Student) => {
				if (data) {
					this.activeStudent = data;
					this.activePhase = this.allPhases.find(
						(phase) => Number(phase.assessmentBookId) == Number(this.activeStudent.assessmentBookId)
					);
					console.log('Student page this.activeStudent: ', this.activeStudent);
					localStorage.setItem('activePhase', JSON.stringify(this.activePhase)); //need this in localstorage on Init, to know what phase we are in for Print title.
					this.loading = true;

					this.StudentService.readyForNextPhase(
						//This is returning Phase 1 for students placing in higher phases (example confirmed phase 3)
						data.id,
						this.activeStudent.assessmentBookId,
						this.activeStudent.assessmentTemplateId
					).subscribe((ready) => {
						if (ready.pass === true) {
							this.showPopUpPhase = true;
							this.activeStudent.assessmentBookId == 1013 ? (this.showLastPhase = true) : (this.showLastPhase = false);
						}
					});
					this.StudentService.getScoreTotal$(
						data.id,
						this.currentTestSystem.id,
						this.activeStudent.assessmentBookId,
						this.activeStudent.assessmentTemplateId
					).subscribe((data) => {
						this.totalScore = data.total;
						this.loading = false;
						this.getcolorScale(this.totalScore);
					});
				} else {
					this.activeStudent = null;
				}
			});
		});
	}

	setPopout() {
		this.showPopUpPhase = false;
	}

	toggle(popover) {
		if (this.showPopUpPhase === true) {
			popover.open();
		}
	}
	changePhase(phase, popover) {
		popover.close();

		this.activeStudent.phases.forEach((obj) => {
			obj.status = 'Complete';
		});

		const index = this.activeStudent.phases.findIndex((object) => {
			return object.assessmentTemplateId === phase.assessmentTemplateId;
		});

		if (index !== -1) {
			this.activeStudent.phases[index].status = 'Current';
		}

		const newUser = {
			...this.activeStudent,
			assessmentTemplateId: parseInt(phase.assessmentTemplateId),
			assessmentBookId: parseInt(phase.assessmentBookId),
		};
		this.StudentService.setStudent(newUser);
		localStorage.setItem('activePhase', JSON.stringify(phase));
		this.activePhase = phase;
		this.phaseService.setPhase(phase);
	}

	getcolorScale(score: any) {
		if (score < 19) {
			this.color = '#fffaeb';
		} else if (score >= 20 && score < 40) {
			this.color = '#cd9c5a';
		} else if (score >= 40 && score < 60) {
			this.color = '#b4b4b4';
		} else if (score >= 60 && score < 80) {
			this.color = '#c9b037';
		} else if (score >= 80) {
			this.color = '#e5e4e2';
		}
		console.log(this.color);
		return this.color;
	}
	ngOnDestroy() {
		this.selectedStudent.unsubscribe();
	}
}
